import axios from "axios";

import { authLogout } from "@/redux/actions/auth.actions";
import { SET_MESSAGE } from "@/redux/types/message.types";

let interceptorsConfigured = false;

export default {
	setupInterceptors: (store) => {
		if (interceptorsConfigured) return;
		interceptorsConfigured = true;

		axios.interceptors.response.use(
			(response) => {
				return response;
			},
			(error) => {
				const shouldSkipGlobalMessage = Boolean(error?.config?.url?.includes("/admin/integrations/import_excel"));

				switch (error.response.status) {
					case 400:
						if (!shouldSkipGlobalMessage && error.response.data && error.response.data.data) {
							let error_message = "";
							if (error.response.data.data.toLowerCase().includes("client error")) {
								error_message = "Se ha producido un error inesperado, por favor comunique con administración.";
							}

							store.dispatch({
								type: SET_MESSAGE,
								payload: {
									message: error_message || error.response.data.data,
									type: "error",
								},
							});
						}

						break;
					case 409:
						if (!shouldSkipGlobalMessage) {
							store.dispatch({
								type: SET_MESSAGE,
								payload: {
									message: error.response.data.data,
									type: "error",
								},
							});
						}
						return error.response;
					case 401:
						store.dispatch(authLogout()).then(() => {
							globalThis.location.href = `${process.env.PUBLIC_URL}/acceso`;
						});
						break;
					default:
						break;
				}

				return Promise.reject(error);
			},
		);
		axios.interceptors.request.use(function (config) {
			const token = localStorage.getItem("token");
			const API_GO = process.env.REACT_APP_API_GO || process.env.VITE_API_GO;

			if (API_GO && config.url?.includes(API_GO)) {
				config.headers.Authorization = token;
				config.headers["X-Source"] = "web";
			} else {
				config.headers.Authorization = token;
			}

			return config;
		});
	},
};
